import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import {
    useImageLoading,
    SkeletonLoading,
    useIdentificationContext,
    Variant,
} from '@fiverr-private/identification_core';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { CheckIcon } from '@fiverr-private/visuals';
import standardImage from '../../../assets/standard.png';
import goVariantImage from '../../../assets/go_main.png';
import { responsiveImg } from '../../../shared/styles/index.ve.css';
import { appTranslate } from '../../../i18n';
import { EDUCATION_ITEMS_COPY_KEYS, GO_EDUCATION_ITEMS_COPY_KEYS } from './DefaultIllustrationBanner.constants';

const getIllustrationImage = (variant: Variant) => {
    switch (variant) {
        case 'go':
            return goVariantImage;
        case 'default':
        default:
            return standardImage;
    }
};

export const DefaultIllustrationBanner = () => {
    const { variant } = useIdentificationContext();
    const imageSrc = getIllustrationImage(variant);
    const { loading, onLoad } = useImageLoading(imageSrc);

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <Container width="100%" paddingY="14" paddingX="10" position="absolute">
                    {variant === 'default' && (
                        <>
                            <Heading color="white" as="h2">
                                {appTranslate('identification.banner.education.title')}
                            </Heading>
                            <List paddingLeft="0" marginTop="6">
                                {EDUCATION_ITEMS_COPY_KEYS.map((key, index) => (
                                    <ListItem key={index} marginBottom="2">
                                        <ListItemIcon>
                                            <CheckIcon size="xs" color="white" />
                                        </ListItemIcon>
                                        <Text size="b_lg" color="white">
                                            {appTranslate(key)}
                                        </Text>
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )}
                    {variant === 'go' && (
                        <>
                            <Heading
                                color="white"
                                as="h2"
                                marginBottom="6"
                                style={{ fontFamily: 'PowerGrotesk', fontWeight: 500 }}
                            >
                                {appTranslate('identification.banner.education.variant_go.title')}
                            </Heading>
                            <List paddingLeft="0">
                                {GO_EDUCATION_ITEMS_COPY_KEYS.map((key, index) => (
                                    <ListItem key={index} marginBottom="1">
                                        <ListItemIcon>
                                            <CheckIcon color="white" />
                                        </ListItemIcon>
                                        <Text color="white">{appTranslate(key)}</Text>
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )}
                </Container>

                <img
                    onLoad={onLoad}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                    className={responsiveImg}
                    src={imageSrc}
                />
            </Container>
        </SkeletonLoading>
    );
};
